/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { html, nothing } from 'lit';
// eslint-disable-next-line import/extensions
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

import { ConsentType } from '@mfe/types/common';
import type TefComsConsent from '../../tef-coms-consent';
import { doToggle, localDate, localTime } from '../util';

export const consentTemplate = (consentClasses: string[], checkboxClasses: string[], consent: ConsentType, disabled: boolean, comsConsent: TefComsConsent) => html`
  <div class="${consentClasses.join(' ')}">
  ${consent.hintBefore ? html`<div class="coms-hint-before">${unsafeHTML(consent.hintBefore)}</div>` : nothing}
    ${!disabled ? html`
    <div class="${checkboxClasses.join(' ')}">
      <input
        type="checkbox"
        .checked=${consent.granted}
        @click="${doToggle({ id: consent.id })}"
          id="${consent.id}"
          name="${consent.id}"
      >
      <label for=${consent.id}>
        ${unsafeHTML(consent.scope)}
      </label>
    </div>
    ` : html`
      <div>
        <tef-coms-icon .icon="${consent.granted ? 'check' : 'cross'}" size="l"></tef-coms-icon>
        <span>
            ${unsafeHTML(consent.scope)}
        </span>
      </div>
    `}
    ${comsConsent.features}
    ${consent.hintAfter ? html`<div class="coms-hint-after">${unsafeHTML(consent.hintAfter)}</div>` : nothing}
  </div>
    ${consent.clientDisplay && localDate(consent.date) ? html`
        <small>
            <tef-coms-icon icon="clock"></tef-coms-icon>
            Letzte Änderung am
            ${localDate(consent.date)} um ${localTime(consent.date)} Uhr über ${consent.clientDisplay}
        </small>
    ` : nothing}
  `;

export default consentTemplate;
